module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"placeholder":"Classe","economy":"Classe Économique","eco-plus":"Classe Eco Premium","business":"Classe Affaire","first":"Première Classe","errors":{"required":"Ce champ est requis"}},"enf":{"placeholder":"Class","economy":"Economy class","eco-plus":"Eco plus class","business":"Business class","first":"First class","errors":{"required":"Required field"}}}')
  delete Component.options._Ctor
}
